import React from 'react';
import { FileText, ShieldCheck } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '../ui/dialog';
import { LegalContent } from './LegalContent';
import { TERMS_MARKDOWN, PRIVACY_MARKDOWN, LEGAL_EFFECTIVE_DATE } from '../../content/legalContent';

// Modal that displays the Terms & Conditions or Privacy Policy.
// `doc` = 'terms' | 'privacy'. Used from the avatar dropdown.
export const LegalDialog = ({ open, onOpenChange, doc = 'terms' }) => {
  const isTerms = doc === 'terms';
  const title = isTerms ? 'Terms & Conditions' : 'Privacy Policy';
  const Icon = isTerms ? FileText : ShieldCheck;
  const markdown = isTerms ? TERMS_MARKDOWN : PRIVACY_MARKDOWN;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl h-[85vh] p-0 flex flex-col gap-0" data-testid="legal-dialog">
        <DialogHeader className="px-6 pt-6 pb-3 border-b flex-shrink-0">
          <DialogTitle className="flex items-center gap-2" data-testid="legal-dialog-title">
            <Icon className="w-5 h-5 text-[#2563eb]" />
            {title}
          </DialogTitle>
          <DialogDescription>EnsueLIVETRAK — Effective {LEGAL_EFFECTIVE_DATE}</DialogDescription>
        </DialogHeader>
        <div className="flex-1 overflow-y-auto px-6 py-5" data-testid="legal-dialog-body">
          <LegalContent markdown={markdown} />
        </div>
      </DialogContent>
    </Dialog>
  );
};
